"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { forwardRef } from "react"
import { jobInfoClick, Link } from "utils"

type Props = {
  job: any
  tabIndex?: number
}

const StyeldJobItem = styled.div`
  box-shadow: 0px 2px 8px 0px #26303d29;
  min-height: 179px;
  padding: 16px;
  border-radius: 12px;
`

const StyledLinkDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;
  background-color: #008761;
  font-size: 20px;
  height: 48px;
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
`
const StyledTitle = styled(Typography)<{ component?: React.ElementType }>`
  font-size: 24px;
  margin: 0px;
`
const JobItem = forwardRef<HTMLDivElement, Props>(({ job, tabIndex }, ref) => {
  return (
    <div ref={ref} tabIndex={tabIndex} role="listitem">
      <StyeldJobItem>
        <StyledTitle component="h3" style={{ fontWeight: 700 }}>
          {job?.jobTitle}
        </StyledTitle>
        <Typography
          variant="body1"
          style={{ paddingTop: "24px", fontSize: "18px" }}
        >
          <span style={{ fontWeight: 700 }}>{"תחום: "}</span>

          {job?.categoryName}
        </Typography>
        <StyledLinkDiv>
          <StyledLink
            href={`/career/headquarters/${job.jobId}`}
            onClick={() => {
              jobInfoClick("לפרטי המשרה", job.jobTitle, job.categoryName)
            }}
          >
            לפרטי המשרה
          </StyledLink>
        </StyledLinkDiv>
      </StyeldJobItem>
    </div>
  )
})

JobItem.displayName = "JobItem"

export default JobItem
